import { Component, OnInit } from '@angular/core';
import { CmsDataSettings } from 'src/app/models/cmsdata';
import { DataService } from 'src/app/services/data.service';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit {

  public settings: CmsDataSettings;
  public bgImage: string = "unset";

  constructor(
    private dataService: DataService
  )
  {
    this.subscribe();
  }

  ngOnInit(): void {
  }

  subscribe() {
    this.dataService.settings.subscribe((data) => {
      this.settings = data;
      if (data.header_background) {
        this.bgImage = `url('${data.header_background}')`;
      } else {
        this.bgImage = "unset";
      }
    });
  }

}
